exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-scale-label[data-v-022eaa19] {\n  margin: 0 10px;\n}\n", ""]);

// exports
